import { ROUTES } from "@/constants/routes";
import { route } from "@/utils/route";

/**
 * Blocks have no detail pane. A block reached by id from outside its canvas
 * (search, a list, a chat message, a stale link) is sent to its canvas with
 * this request in the navigation state; the canvas expands the block's node
 * into the lightbox once the document has loaded
 * (useExpandFileRecordOnArrival), then clears the request.
 */
export const CANVAS_EXPAND_FILE_RECORD_STATE_KEY = "expandFileRecordId";

export function readExpandFileRecordId(state: unknown): string | null {
  const value = (state as Record<string, unknown> | null | undefined)?.[
    CANVAS_EXPAND_FILE_RECORD_STATE_KEY
  ];
  return typeof value === "string" && value !== "" ? value : null;
}

/** Navigation target for opening `fileRecordId` full-size on `canvasId`. */
export function buildCanvasBlockNavigation(
  canvasId: string,
  fileRecordId: string,
): { to: string; state: Record<string, unknown> } {
  return {
    to: route(ROUTES.CANVAS.DETAIL, { canvasId }),
    state: { [CANVAS_EXPAND_FILE_RECORD_STATE_KEY]: fileRecordId },
  };
}
